import { render, staticRenderFns } from "./AllocatedOrders.vue?vue&type=template&id=4df51d8c&"
import script from "./AllocatedOrders.vue?vue&type=script&lang=js&"
export * from "./AllocatedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df51d8c')) {
      api.createRecord('4df51d8c', component.options)
    } else {
      api.reload('4df51d8c', component.options)
    }
    module.hot.accept("./AllocatedOrders.vue?vue&type=template&id=4df51d8c&", function () {
      api.rerender('4df51d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/AllocatedOrders.vue"
export default component.exports